import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Widget } from "components/Widget/Widget";
import { getSalesInfo } from "pages/DashboardPage/api/api";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Link } from "react-router-dom";
import { ICON_TYPE } from "utils/constants";

import { trans } from "utils/helpers";
import { getData } from "./api";

interface props {
    type:any
    title:any
    subTilte:any
    route:any
    icon?:any
    color:any,
    data?:any
    setData?:any
    url?:any,
    baseUrl?:any,
    params?:any
    customStyle?:any
}

export const ShortcutWidget = ({
  type,
  title,
  subTilte,
  route,
  icon,
  color,
  setData,
  url,
  baseUrl,
  params,
  customStyle
}: props) => {


const getDataAsync=async()=>{
    try{
        const res=await getData(baseUrl,url,params)
        setData(res)
    }catch(error){}
}

    useEffect(()=>{
        if(url){

            getDataAsync()
        }
    },[type])
  return (
    <>
      <Link className="position-relative" to={route}>
        <div className="shadow itemDetail__fixPropertiesBx__propertiesItem glassBox my-2  p-2 align-items-center  row">
          <div className="col-2 p-0">
            <FontAwesomeIcon
              icon={[ICON_TYPE, icon]}
              className={color}
              size="3x"
            />
          </div>
          <div className="col-10 me-1 row flex-column">
            <div className={`col-12  mb-1 `} style={{fontWeight:'700', fontSize: "15px",...customStyle, }}>
              {title}
            </div>
            <div className="col-12 ">{subTilte}</div>
          </div>
        </div>
      </Link>
    </>
  );
};
